export default class Partners {

  constructor(el) {
    this.$el = el;
    this.swiper = this.initSwiper();
  }



  initSwiper() {

    const swiper = new Swiper(this.$el.querySelector(".swiper"), {
      speed: 1600,
      loop: true,
      autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      },
      roundLengths: true,
      slidesPerView: 2,
      spaceBetween: 16,
      breakpoints: {
      640: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 32,
      },
      1500: {
        slidesPerView: 6,
        spaceBetween: 32,
      },
      },
      a11y: false, // Turn off ARIA accessibility support
    });

    return swiper

  }
}
